import { useTheme } from '../theme/ThemeContext';
import { BRAND_GREEN, BRAND_GREEN_CC, forestTopbarIconButtonClass } from '../theme/themeStyles';

type Props = {
  size?: 'sm' | 'md';
  className?: string;
  surface?: 'default' | 'forest';
};

export default function ThemeToggle({ size = 'md', className = '', surface = 'default' }: Props) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const sizeClass = size === 'sm' ? 'h-9 w-9' : 'h-10 w-10';
  const iconClass = size === 'sm' ? 'text-lg' : 'text-xl';

  if (surface === 'forest') {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        title={isDark ? 'Light mode' : 'Dark mode'}
        data-tour-id="theme-toggle"
        className={[forestTopbarIconButtonClass(theme), className].join(' ')}
      >
        <i className={`${isDark ? 'ri-sun-line' : 'ri-moon-line'} text-base`} aria-hidden />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      data-tour-id="theme-toggle"
      className={[
        'flex items-center justify-center rounded-full backdrop-blur-sm shadow-md transition-colors',
        sizeClass,
        isDark
          ? 'bg-gray-800/95 border border-gray-600 text-amber-300 hover:bg-gray-700 hover:border-gray-500'
          : 'bg-white/95 border border-gray-200 hover:border-[#00854080]',
        className,
      ].join(' ')}
      style={isDark ? undefined : { color: BRAND_GREEN_CC }}
    >
      <i
        className={`${isDark ? 'ri-sun-line' : 'ri-moon-line'} ${iconClass}`}
        aria-hidden
        style={isDark ? undefined : { color: BRAND_GREEN }}
      />
    </button>
  );
}
